import languagesMain from '@whitelabel/helpers/languages.json';
import { ILocales } from '@whitelabel/helpers/types';
import { isOnServer } from '@whitelabel/helpers/utils';

import { MOMENT_CODES, RC_AFFILIATE_LINK } from './constants';
import languagesRC from './constants/languagesRC.json';

const getLocaleData = (xcode: string) => {
  // Get locale on xcode format from languagesMain (helpers package). flagMap also uses xcode
  const { nameLocal, bidi } = languagesMain[xcode as keyof typeof languagesMain] ?? {
    nameLocal: 'English',
    bidi: false,
  };

  return {
    nameLocal,
    bidi,
  };
};

type ILocalesBase = Omit<ILocales, 'Flag'> & { xcode: string };

export const locales = Object.keys(languagesRC).reduce<Record<string, ILocalesBase>>((availableLocales, locale) => {
  const { urlPrefix, name, xcode } = languagesRC[locale as keyof typeof languagesRC];
  const { nameLocal, bidi: isRTL } = getLocaleData(xcode);

  availableLocales[locale] = {
    // use urlPrefix as advised by RC team
    code: urlPrefix,
    momentCode: MOMENT_CODES[locale as keyof typeof MOMENT_CODES] || urlPrefix,
    name,
    nameLocal,
    isRTL,
    xcode,
  };
  return availableLocales;
}, {});

export const isRCAffiliateLink = (): boolean | undefined => {
  if (isOnServer) return undefined;

  if (document.location.ancestorOrigins) return document.location.ancestorOrigins.contains(RC_AFFILIATE_LINK);

  /**
   * Some browsers don't support ancestorOrigins due to security reasons
   * In such scenario, user can't use affiliate page because there is no way for the app to detect the user real url
   * Read more: https://bugzilla.mozilla.org/show_bug.cgi?id=1085214
   */
  return false;
};
